import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">话题标签</h2>
          <span className="text-xs text-foreground-500 mt-1">实时热力追踪</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topicItems.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-9 h-9 rounded-md bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-base text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{topic.name}</h3>
                  {topic.trend === 'up' && (
                    <i className="ri-arrow-up-s-fill text-xs text-primary-500 flex-shrink-0"></i>
                  )}
                  {topic.trend === 'down' && (
                    <i className="ri-arrow-down-s-fill text-xs text-secondary-500 flex-shrink-0"></i>
                  )}
                </div>
                <span className="text-[11px] text-foreground-400">讨论 {topic.heat}</span>
              </div>
            </div>
          ))}

          <div className="flex items-center justify-center p-4 bg-background-50 rounded-lg border border-dashed border-background-300 cursor-pointer hover:border-primary-300 transition-colors">
            <span className="text-sm text-foreground-500">查看更多标签 →</span>
          </div>
        </div>
      </div>
    </section>
  );
}